<template>
  <v-card flat>
    <v-card-text v-if="!loading">
      <div v-for="(item, index) in list" :key="index">
        <div style="display: flex; flex-direction: row; text-align: left">
          <span style="font-weight: bold; font-size: 15px; flex: 1; text-align: right">{{ item.shop.shop_name }}</span>
          <v-btn @click="orderFunction(item)" v-if="item.status_btn != null && item.status_btn.length > 0"
                 class="btn-order" color="#7ec352" rounded>{{ item.status_btn }}
          </v-btn>
          <div v-else class="d-flex flex-row">
            <i class="mdi mdi-circle" style="font-size: 5px; margin-left: 5px"></i>
            <p :style="'font-size:10px; color : ' + item.status_color">
              {{ item.status_label }}
            </p>
          </div>
        </div>
        <p style="font-size: 12px">کد سفارش {{ item.order_type != 1 ? 'حضوری' : 'دلیوری' }}:
          <span style="font-family: sans-serif; font-weight: bold">{{ item.order_code + '#' }}</span>
        </p>
        <div
            style="display: flex; justify-content: space-between;align-items: center; text-align: left; margin-bottom: 10px">
          <div style="display: flex; align-items: center">
            <v-icon style="font-size: 17px; color: #7ec352; margin-bottom: 5px; margin-left: 5px">
              schedule
            </v-icon>
            <span style="font-size: 12px; direction: ltr">{{ oracle.formatDate(item.create_at) }}</span>
          </div>
          <div style="width: 150px; display: flex;justify-content: left;">
                                                <span v-if="item.order_state != 1 && item.order_state != 6"
                                                      style="margin-left: 5px ;padding: 2px 10px; font-size: 9px; text-align: center; background: #222; color: white; border-radius: 15px;"
                                                      role="button" v-ripple
                                                      @click="$router.push({name:'Tracking', query:{id:item.order_id}})">پیگیری سفارش</span>
            <span
                style="padding: 2px 10px; font-size: 9px; text-align: center; border: 1px solid rgba(133, 133, 133, 0.35); border-radius: 15px;"
                role="button" v-ripple
                @click="loading = true, (item.visible != null && item.visible ? item.visible = false : item.visible = true), loading = false">
                                        {{ item.visible != null && item.visible ? 'بستن' : 'فاکتور خرید' }}
                        </span>
          </div>
        </div>
        <div style="padding: 0 8px 0 8px; background-color: #f8f8f8;
                            margin-bottom: 10px; border-radius: 8px" v-if="item.visible != null && item.visible">
          <div v-for="(it , index) in item.order_detail"
               :key="index">
            <div style="display: flex; align-items: center; justify-content: space-between; text-align: left">
              <span class="multi-line"
                    style="font-size: 12px; text-align: right;">{{
                  it.product_title + " " + "(" + it.product_quantity + " عدد)"
                }}</span>
              <p style="color: #7ec352; font-size: 11px; margin-bottom: 5px; margin-top: 5px">
                {{ oracle.format(it.product_sell_price) }} تومان</p>
            </div>
          </div>
          <div style="background: #6c757d; border-radius: 5px;" class="pl-2 pr-2 pt-2 pb-2"
               v-if="item.order_options_text != null && item.order_options_text.length > 0">
            <span style="white-space: pre-wrap; color: white"
                  class="f8">{{ item.order_options_text }}</span>
          </div>
          <div v-if="item.order_delivery != null && item.order_delivery > 0"
               style="display: flex; align-items: center; justify-content: space-between; text-align: left">
            <span class="multi-line" style="font-size: 12px; text-align: right;">هزینه ارسال با پیک</span>
            <p style="color: #7ec352; font-size: 11px; margin-bottom: 5px; margin-top: 5px">
              {{ oracle.format(item.order_delivery) }} تومان</p>
          </div>
          <div v-if="item.order_options_price != null && item.order_options_price > 0"
               style="display: flex; align-items: center; justify-content: space-between; text-align: left">
            <span class="multi-line" style="font-size: 12px; text-align: right;">هزینه ملزومات سفارش</span>
            <p style="color: #7ec352; font-size: 11px; margin-bottom: 5px; margin-top: 5px">
              {{ oracle.format(item.order_options_price) }} تومان</p>
          </div>
          <div style="height: 1px; width: 100%; background-color: #e7e7e7"></div>
          <div style="display: flex; align-items: center; justify-content: space-between; text-align: left">
            <span style=" font-size: 12px; font-weight: bold">جمع کل پس از تخفیف</span>
            <p style="color: #7ec352; font-size: 11px; margin-bottom: 5px; margin-top: 5px">
              {{ oracle.format(item.order_price) }} تومان</p>
          </div>
        </div>
        <div style="height: 1px; width: 100%;margin-bottom: 10px; background-color: #9a9696"></div>
      </div>
    </v-card-text>
    <v-dialog v-model="ratingModal">
      <v-card class="profile pr-4 pl-4 pb-5 pt-5 text-right">
        <div class="d-flex flex-column align-center">
          <span class="ml-5 mr-5 f11 font-weight-bold align-self-start">ثبت نظر و امتیاز</span>
          <span class="ml-5 mr-5 f8 mb-3 mt-1 align-self-start">نظر، انتقاد و یا پیشنهاد خود را راجع به سرویس دهی و کیفیت سفارش خود با ما به اشتراک بگذارید.</span>
          <v-rating dir="ltr" size="48" v-model="rating" color="#7dc353" background-color="#7dc353"></v-rating>
          <v-textarea
              solo
              style="width: 100%"
              class="mb-5"
              placeholder="متن نظر، انتقاد و یا پیشنهاد"
              v-model="ratingNote"
          ></v-textarea>
          <div class="d-flex flex-row mt-5 ml-5 mr-5 mb-5 btn-modal-creat justify-space-between"
               style="width: 100%;">
            <v-btn rounded class="text--white"
                   width="120px" @click="ratingModal = false">
              <span style="color: black" class="f9">انصراف</span>
            </v-btn>
            <v-btn rounded color="#7dc353" class="text--white"
                   type="primary" width="200px" @click="setReview">
              <span style="color: white" class="f9 font-weight-bold">ثبت و ارسال بازخورد</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import oracle from "@/utils/oracle";

export default {
  name: "OrderList",
  data() {
    return {
      oracle: oracle,
      loading: false,
      ratingModal: false,
      rating: 5,
      currentOrderReview: null,
      ratingNote: "",
    }
  },
  props: {
    updateList: null,
    list: []
  }, methods: {
    orderFunction(item) {
      if (item.order_state == 6) {
        this.currentOrderReview = item
        this.ratingModal = true
      }
    }, setReview() {
      this.oracle.axios("review/create", {
        order_id: this.currentOrderReview.order_id,
        comment_rate: this.rating,
        comment_text: this.ratingNote,
      }, () => {
        this.currentOrderReview.review = {}
        this.rating = 5
        this.ratingNote = ""
        this.ratingModal = false
        oracle.showMessage("بازخورد شما با موفقیت ثبت شد!", null, null, true)
        if (this.updateList != null) this.updateList()
      })
    }
  }
}
</script>

<style>
.btn-order {
  height: 25px !important;
  color: white !important;
}
</style>